export class ScrubImportModel {
   public NPI = '';
   public TAX_ID = '';
   public NAME = '';
   public HITS = '';
   public TOTAL_AMOUNT = '';
}
